import { cn } from "@/lib/utils";
import { CONTACT_STATUS, TON_KLASSEN, type Ton } from "@/lib/labels";
import type { ContactStatus } from "@/generated/prisma/enums";

/** Kleines Etikett in Statusfarbe — fuer jeden Enum mit Ton (`lib/labels.ts`). */
export function TonBadge({ ton, children, className }: { ton: Ton; children: React.ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        "text-caption inline-flex shrink-0 items-center rounded-full px-2 py-0.5 font-medium whitespace-nowrap",
        TON_KLASSEN[ton],
        className,
      )}
    >
      {children}
    </span>
  );
}

export function ContactStatusBadge({ status, className }: { status: ContactStatus; className?: string }) {
  const s = CONTACT_STATUS[status];
  return (
    <TonBadge ton={s.ton} className={className}>
      {s.label}
    </TonBadge>
  );
}
